Vue.component('seasonalleaderboard', {
    template: templates.seasonalLeaderBoard,
    data() {
      return {
        model: {
     
        }
      }
    },
    mounted() {
      const c = this;
     
    },
    methods: {
     
  
    
    
    }
  });